import { Grid, Text, Flex, Skeleton, Link, VStack } from '@chakra-ui/react';
import React, { FC, useState } from 'react';
import { ListPagination } from '@app/screens/pools/components/ListPagination';
import { RewardNftsFilter } from '@app/screens/nft-marketplace/RewardNfts/RewardNftsFilter';
import { useRewardNftsMarketplaceListings } from '@app/hooks/nft/useGetRewardNftsMarketplaceListings';
import { RewardCard } from '@app/components/RewardCard';
import { FeaturedCollections } from '@app/screens/nft-marketplace/RewardNfts/FeaturedCollections';
import { useRewardNftsMarketplaceFiltersState } from '@app/state/rewardsNftsMarketplaceFiltersStore';
import { APP_ROUTES } from '@app/constants/routes';
import { useMedia } from 'react-use';

const ITEMS_PER_PAGE = 12;

const CardPlaceholder = () => (
  <Skeleton
    width="226px"
    height="285px"
    startColor="neutral.700"
    endColor="neutral.800"
  />
);

export const RewardNfts: FC = () => {
  const isMobile = useMedia('(max-width: 960px)', true);
  const [activePage, setActivePage] = useState(0);
  const { data, isLoading } = useRewardNftsMarketplaceListings();
  const { collection } = useRewardNftsMarketplaceFiltersState();

  const renderRows = () => {
    const startIndex = activePage * ITEMS_PER_PAGE; // calculate the starting index
    const endIndex = startIndex + ITEMS_PER_PAGE; // calculate the ending index

    const paginatedData = data
      ?.filter(item => {
        if (collection) {
          return (
            item.nftContractAddress.toLowerCase() === collection.toLowerCase()
          );
        }

        return true;
      })
      .slice(startIndex, endIndex);

    if (!paginatedData) {
      return null;
    }

    return paginatedData.map(item => (
      <Link key={item.id} href={APP_ROUTES.nftRewardDetailsPage(item.id)}>
        <RewardCard listing={item} />
      </Link>
    ));
  };

  return (
    <>
      <FeaturedCollections />
      <RewardNftsFilter isMobile={isMobile} />
      {isLoading && (
        <Grid templateColumns="repeat(auto-fill, minmax(226px, 1fr))" gap={4}>
          <CardPlaceholder />
          <CardPlaceholder />
          <CardPlaceholder />
          <CardPlaceholder />
        </Grid>
      )}
      {data && !data.length && (
        <Flex minHeight="300px" width="100%" align="center" justify="center">
          <Text color="neutral.400" fontSize="32px">
            No data found
          </Text>
        </Flex>
      )}
      {data && !!data.length && (
        <Grid
          placeItems="center"
          width="100%"
          templateColumns="repeat(auto-fill, minmax(226px, 1fr))"
          gap={4}
        >
          {renderRows()}
        </Grid>
      )}
      {!!data?.length && (
        <ListPagination
          activePage={activePage}
          totalPages={Math.ceil(data?.length / ITEMS_PER_PAGE)}
          onPrev={() => setActivePage(activePage - 1)}
          onNext={() => setActivePage(activePage + 1)}
        />
      )}
    </>
  );
};
